import { render } from "./FaQuestions.vue?vue&type=template&id=81e3a088&scoped=true"
import script from "./FaQuestions.vue?vue&type=script&lang=js"
export * from "./FaQuestions.vue?vue&type=script&lang=js"

import "./FaQuestions.vue?vue&type=style&index=0&id=81e3a088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e3a088"]])

export default __exports__